import React, { useState } from "react";
import stepThreeProgress from "../../../../assets/images/brand-steps-progress-indicator/step-three.svg";
import Proptypes from "prop-types";
import styles from "./addbrand.module.scss";
import Input from "../../../Shared/Textfield";
import Button from "../../../Shared/Button";

const StepThree = ({ setStep, toggle, handleChange, formik }) => {
  const [errors, setErrors] = useState({
    role: "",
    name: "",
    email: "",
  });

  return (
    <>
      <div className={styles["progress_container"]}>
        <div className={styles["progress_container_indicator"]}>
          <img src={stepThreeProgress} width={232} height={42} alt="progress" />
        </div>
      </div>

      <div
        style={{
          marginTop: "9px",
          marginBottom: "20px",
        }}
      >
        <p className={styles["heading_container"]}>Point of Contact Info</p>
      </div>
      <div
        style={{
          marginBottom: "12px",
        }}
      >
        <Input
          value={formik.values.role}
          error={errors.role}
          touched={errors.role}
          onChange={handleChange}
          handleBlur={formik.handleBlur}
          name="role"
          id="role"
          type="text"
          placeholder="Role"
          className={styles["input_field_styles"]}
        />
      </div>

      <div
        style={{
          marginBottom: "12px",
        }}
      >
        <Input
          value={formik.values.name}
          error={errors.name}
          touched={errors.name}
          onChange={handleChange}
          handleBlur={formik.handleBlur}
          name="name"
          id="name"
          type="text"
          placeholder="Name"
          className={styles["input_field_styles"]}
        />
      </div>
      <div
        style={{
          marginBottom: "150px",
        }}
      >
        <Input
          value={formik.values.email}
          error={errors.email}
          touched={errors.email}
          onChange={formik.handleChange}
          handleBlur={formik.handleBlur}
          name="email"
          id="email"
          type="email"
          placeholder="Email"
          className={styles["input_field_styles"]}
        />
      </div>
      <div className={styles["submit_btns"]}>
        <div className={styles["button_div"]}>
          <Button
            className={styles["button_style_cancel"]}
            onClick={() => {
              toggle();
            }}
            text="Cancel"
          />
        </div>
        <div className={styles["button_div"]}>
          <Button
            className={styles["button_style_add"]}
            onClick={() => {
              // setStep(3);

              if (formik.values.email === "") {
                setErrors({
                  email: "Required",
                  name: "",
                  role: "",
                });
              }
              if (formik.values.name === "") {
                setErrors({
                  name: "Required",
                  email: "",
                  role: "",
                });
              }

              if (formik.values.role === "") {
                setErrors({
                  role: "Required",
                  email: "",
                  name: "",
                });
              }

              if (
                formik.values.email !== "" &&
                formik.values.name !== "" &&
                formik.values.role !== ""
              ) {
                setStep(3);
              }
            }}
            text="Add Brand"
          />
        </div>
      </div>
    </>
  );
};
StepThree.propTypes = {
  setStep: Proptypes.func,
  toggle: Proptypes.func,
  handleChange: Proptypes.func,
  formik: Proptypes.object,
};
export default StepThree;
